import {useTheme} from "@mui/material";
import {observer} from "mobx-react";
import * as React from "react";
import {useNavigate, useParams} from "react-router-dom";
import FilledButton from "../../components/buttons/FilledButton";
import DeliverySiteOnboardingRequestFormScreen from "../../components/forms/DeliverySiteOnboardingRequestFormScreen";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import {useApplication} from "../../ApplicationProvider";
import {useNavigatorFeature} from "../../useFeature";
import {styles} from "../orders/create_order/CreateOrderStyles";
import DeliverySiteOnboardingFeature from "./DeliverySiteOnboardingFeature";


function DeliverySiteOnboardingScreen({id: idProp, readonly = false}) {
    const application = useApplication();
    const theme = useTheme();
    const navigator = useNavigate();
    const {id: idFromParams} = useParams();
    const id = idProp || idFromParams;
    const style = styles(theme);
    const isReadonly = readonly || !application.canManageDeliverySiteOnboardings();
    const feature = useNavigatorFeature(
        () => new DeliverySiteOnboardingFeature(application, navigator, null, id, isReadonly),
        navigator,
        [id, isReadonly]
    );

    const isFeatureReady = () => {
        return feature && feature.loaded;
    };

    const editForm = () => {
        return isFeatureReady() && (
            <div>
                <DeliverySiteOnboardingRequestFormScreen
                    deliverySite={feature.form}
                    jurisdictionsOptions={feature.jurisdictionsFieldOptions()}
                    zonesOptions={feature.zonesFieldOptions()}
                    frequenciesOptions={feature.frequenciesFieldOptions()}
                    zonesFrequencyForDeliverySite={(deliverySiteOnboardingRequestForm) =>
                        feature.chosenZoneFrequency(deliverySiteOnboardingRequestForm)}
                />
                {feature.canEditDeliverySitesOnboardingRequests() && (
                    <div style={style.buttonsContainer}>
                        <FilledButton
                            disabled={!feature.canSendToAuthorization()}
                            onClick={() => feature.editOrCreateDeliverySiteOnboardingAuthorizations()}
                        >
                            Enviar a Autorizar
                        </FilledButton>
                    </div>
                )}
            </div>
        );
    };

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady()} renderContent={() => editForm()}/>
    );
}

export default observer(DeliverySiteOnboardingScreen);
